import React from "react";
import { SUB_DIRCTORY } from "../../../app_config";

const cameraSettingsRoutes = [
  {
    path: `${SUB_DIRCTORY}/camera-settings/:action/:id?`,
    component: React.lazy(() => import("./AddCameraSettings")),
  },
  {
    path: `${SUB_DIRCTORY}/camera-settings`,
    component: React.lazy(() => import("./CameraSettingsList")),
  },
];

export default cameraSettingsRoutes;
